<div class="row mb-15px  pt-40" id="approvals1">
    <div class="col-md-2 w-13 align-self-center">
        <h6 class="loginHeadingText text-start my-0">REVIEW / APPROVAL</h6>
    </div>
    <div class="col-md-4">
        <button class="btn progressBtn ps-2" role="button" (click)="readyForReviewConfirmation()"
         [ngClass]="{'approval-disabled-button':selApprovalVM?.isDisbleReviewRequestBtn}"
          [disabled]="selApprovalVM?.isDisbleReviewRequestBtn">
            <div class="d-flex">
                <div>
                    <img src="assets/images/refreshIcon_blue.png" class="btnrefreshIcon" alt="">
                </div>
                <div>
                    READY FOR REVIEW
                </div>
            </div>
            
        </button>
    </div>
    
    <div class="col-md-2 align-self-center">
        <label for="">APPROVAL STATUS : <span class="" [ngClass]="selApprovalVM?.approvalStage| getApprovalStageColor">{{selApprovalVM?.approvalStatus}}</span></label>
    </div>
    <div class="col-md-4 text-end w-37" *ngIf="showLockIcon">
      <div class="lockedUnlockedBtn alignitemss float-end" [ngClass]="{'approval-disabled-button':isDisableLockIcon}">
          <div class="toggle-button-cover ">
              <div class="button-cover">
                  <div class="button b2" id="button-16" *ngIf="selApprovalVM">
                    
                      <input type="checkbox" class="checkbox"  [checked]="!isCheckedLockedIcon" [ngClass]="{'approval-disabled-button':isDisableLockIcon}"
                      [disabled]="isDisableLockIcon"  (change)="selApprovalVM && lockedUnLockedConfirmation(selApprovalVM)">
                      <div class="knobs">
                          <span></span>
                      </div>
                      <div class="layer"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
 
</div>
<div class="row mb-4" >
  <div class="col-md-2 w-13">
    <label for="">REVIEW COMMENTS</label>
  </div>
  <div class="col-md-4">
<!--     
    <pre>{{selApprovalVM?.isDisbleReviewComments | json}}</pre>
    <pre>{{selApprovalVM?.isDisbleApprovalsBtns | json}}</pre> -->
    <textarea class="form-control h-162 mb-0" spellcheck="false" [(ngModel)]="reviewComments" maxlength="2000" 
    [ngClass]="{'approval-disabled-button':selApprovalVM?.isDisbleReviewComments}"
    [disabled]="selApprovalVM?.isDisbleReviewComments ?? false">
  </textarea>
    <div class="d-flex mt-3 justify-content-between">
      <div>
        <img src="assets/images/document_text_icon_1.png" class="documentIconn" alt="">
      </div>
      <div>
        <button class="btn progressBtn ps-2" role="button" 
        [ngClass]="{'approval-disabled-button':selApprovalVM?.isDisbleReviewComments}"
        [disabled]="selApprovalVM?.isDisbleReviewComments"
        (click)="submitComments()">
          SUBMIT COMMENTS
        </button>
      </div>
    </div>
  </div>
  <div class="col-md-2">
    <!-- <label for="">APPROVAL STATUS : <span class="text-danger">Pending</span></label> -->

    <!-- <button class="bapproveBtnText" (click)="approvedForReviwClick()">
        <h6 class="approveBtnText">APPROVE</h6>
    </button> -->
    <!-- <h6 class="approveBtnText" (click)="approvedForReviwClick()" >APPROVE</h6> -->
      <button class="w-100 approveBtnText" 
      [ngClass]="{'approval-disabled-button':(selApprovalVM?.isDisbleApprovalsBtns || disableApprove)}" 
      (click)="approvedForReviewConfirmation()"
      [disabled]="(selApprovalVM?.isDisbleApprovalsBtns || disableApprove)">

          APPROVE
      </button>

      <button class="w-100 actionRequiredText" 
      [ngClass]="{'approval-disabled-button':(selApprovalVM?.isDisbleApprovalsBtns || disableApprove)}" 
      (click)="actionRequiredConfirmation()"
      [disabled]="(selApprovalVM?.isDisbleApprovalsBtns || disableApprove)">
          ACTION REQUIRED
      </button>
    

            <!-- <h6 class="actionRequiredText">ACTION REQUIRED</h6> -->

  </div>

</div>
<div class="row">
  <div class="col-md-2 w-13">

  </div>
  <div class="col-md-6">
    <label class="mb-2"> REVIEW LOG</label>
    <ng-container *ngIf="showReviewLogs">
    <table class="table datatable border-x-0 mb-0">
      <thead>
        <tr class="subheaderrr">
          <th scope="col" width="15%">ACTION ON</th>
          <th scope="col" width="25%">ACTION BY</th>
          <th scope="col" width="20%">ACTION TYPE</th>
          <th scope="col" width="40%">COMMENTS</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of reviewLogs">
          <td class="textNavyblue">
              <span>{{r.actionDate | date: 'dd-MMM-yyyy'}}</span>
          </td>
          <td>
              {{r.actionBy}}
          </td>

          <td [class]="r?.type| getApprovalStageColor" style="font-weight: 700;">
              {{r.type}}
          </td>
          <td>
              {{r.comment}}
          </td>
      </tr>
       
      </tbody>
    </table>
    </ng-container>
    <ng-container *ngIf="!showReviewLogs">
      <div class="card">
        <div class="card-body py-2 px-3">
            <div class="emtyCard p-0">
                <p class="mb-0">At this moment there are no logs in the system.
                </p>
            </div>
        </div>
    </div>
    </ng-container>
  </div>
</div>
